import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Messages.css';
import Navbar from '../components/Navbar';

function Messages() {
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadConversations();
    
    // Poll for new messages every 5 seconds
    const interval = setInterval(loadConversations, 5000);
    return () => clearInterval(interval);
  }, []);

  const loadConversations = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      console.log('📞 Loading conversations...');
      console.log('🔑 Token exists:', !!token);
      const response = await axios.get('/api/messages/conversations', {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      console.log('✅ Conversations loaded:', response.data.conversations.length, 'conversations');
      console.log('Conversations:', response.data.conversations);
      setConversations(response.data.conversations);
    } catch (error) {
      console.error('❌ Error loading conversations:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
    } finally {
      setLoading(false);
    }
  };

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date.toLocaleDateString();
  };

  return (
    <div>
      <Navbar />

      <div className="messages-page-container">
        <div className="messages-header">
          <h2>Messages</h2>
          <p>Chat with your connections</p>
        </div>

        {loading ? (
          <div className="loading">Loading conversations...</div>
        ) : conversations.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">💬</div>
            <h3>No messages yet</h3>
            <p>Start a conversation with your connections!</p>
            <button onClick={() => navigate('/connections')} className="btn btn-primary">
              View Connections
            </button>
          </div>
        ) : (
          <div className="conversations-list">
            {conversations.map((conv) => (
              <div 
                key={conv.conversationId}
                className="conversation-item"
                onClick={() => navigate(`/chat/${conv.otherUserId}`)}
              >
                <div className="conversation-avatar">
                  {conv.otherUserPhoto ? '📷' : '👤'}
                  {conv.unreadCount > 0 && (
                    <span className="unread-badge">{conv.unreadCount}</span>
                  )}
                </div>
                
                <div className="conversation-content">
                  <div className="conversation-header">
                    <h4>{conv.otherUserName}</h4>
                    <span className="conversation-time">
                      {formatTime(conv.lastMessageAt)}
                    </span>
                  </div>
                  <p className={`conversation-preview ${conv.unreadCount > 0 ? 'unread' : ''}`}>
                    {conv.lastMessage || 'No messages yet'}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Messages;
